export const MERIT_LOADING = "MERIT_LOADING";

export const GET_MERIT_ORDERS_SUCCESS = "GET_MERIT_ORDERS_SUCCESS";
export const GET_MERIT_ORDER_DETAILS_SUCCESS = "GET_MERIT_ORDER_DETAILS_SUCCESS";
export const GET_MERIT_API_LOGS_SUCCESS = "GET_MERIT_API_LOGS_SUCCESS";
export const GET_MERIT_API_LOG_DETAILS_SUCCESS = "GET_MERIT_API_LOG_DETAILS_SUCCESS";

export const MeritLoading = (payload) => ({
  type: MERIT_LOADING,
  payload,
});

export const GetMeritOrdersSuccess = (payload) => ({
  type: GET_MERIT_ORDERS_SUCCESS,
  payload,
});

export const GetMeritOrderDetailsSuccess = (payload) => ({
  type: GET_MERIT_ORDER_DETAILS_SUCCESS,
  payload,
});

export const GetMeritApiLogsSuccess = (payload) => ({
  type: GET_MERIT_API_LOGS_SUCCESS,
  payload,
});

export const GetMeritApiLogDetailsSuccess = (payload) => ({
  type: GET_MERIT_API_LOG_DETAILS_SUCCESS,
  payload,
});
